import { useLocation } from 'react-router-dom';
import HomeHeader from '../components/HomeHeader/HomeHeader.tsx';
import PageFooter from '../components/Footer/Footer';

const isDeveloper = import.meta.env.VITE_DEVELOPER;

interface ErrorState {
  error?: string;
}

function ErrorPage() {
  const location = useLocation();
  const errorState = location.state as ErrorState;

  return (
    <>
      <HomeHeader />
      <div className="nhsuk-width-container">
        <main className="nhsuk-main-wrapper" id="main-content" role="main">
          <div className="nhsuk-grid-row">
            <div className="nhsuk-grid-column-two-thirds nhsuk-u-padding-5 nhsuk-u-margin-3">
              <h2>Something went wrong</h2>
              <p>We&apos;re having some technical issues right now. Please try again later.</p>
              <p>If it keeps happening, get in touch with the SPI team.</p>

              <p>Log out to go back to the SPI homepage.</p>
            </div>
            {isDeveloper && errorState && (
            <div className="nhsuk-grid-row nhsuk-u-padding-1 nhsuk-u-margin-5">
              <div className="nhsuk-grid-column-two-thirds">
                <p className="nhsuk-body-s"><strong>Error Details</strong></p>
                <p className="nhsuk-body-s">
                  {errorState.error}
                </p>
              </div>
            </div>
            )}
          </div>
        </main>
      </div>

      <PageFooter />
    </>
  );
}

export default ErrorPage;
